import {Component} from 'react'
import Navbar from '../Navbar'
import './index.css'

class About extends Component {
  render() {
    return (
      <div className="about-container">
        <Navbar />
        <hr className="line" />
        <div>
          <h1 className="about">ABOUT ME</h1>
          <p className="description">
            Hi, My name is <span className="name">Kukudala Sumanth </span>I have
            done my BSC Computer science from
            <span className="span"> SIVA SIVANI DEGREE COLLEGE </span>in 2022,
            After my Graduation i have decided to get into the IT Sector because
            lot of scope and future in it, to get the required skills to get
            into IT industry i have learned
            <span className="span">MERN STACK DEVELOPMENT</span>, along with
            that I have build some websites like NXTTRENDS, NXTWATCH, JOBBY APP,
            RESTO APP using REACT JS and many other static and Dynamic websites
            using JAVASCRIPT.
          </p>
          <p className="about headline">SKILLS</p>
          <div className="skill-items">
            <img
              src="https://i.pinimg.com/564x/4d/13/d5/4d13d55d6d0b38b7a4e85fcf97ff6279.jpg"
              className="skill-logo"
              alt="skill"
            />
            <img
              src="https://i.pinimg.com/564x/a2/7d/14/a27d14a27b5ef7d35c241d5cc9c1deb4.jpg"
              className="skill-logo"
              alt="skill"
            />
            <img
              src="https://i.pinimg.com/564x/a3/e2/18/a3e21834809a55797f014498b8c345bf.jpg"
              className="skill-logo"
              alt="skill"
            />
            <img
              src="https://i.pinimg.com/564x/82/40/ac/8240ac872c818d2a39ef20d819fdbf0d.jpg"
              className="skill-logo"
              alt="skill"
            />
            <img
              src="https://i.pinimg.com/564x/f8/ee/69/f8ee696f018c1a4ad6b9972b85fc6b2e.jpg"
              className="skill-logo"
              alt="skill"
            />
            <img
              src="https://i.pinimg.com/564x/a5/d2/a9/a5d2a913006aee3504a6882ce38f7959.jpg"
              className="skill-logo"
              alt="skill"
            />
            <img
              src="https://i.pinimg.com/564x/ec/6e/63/ec6e63b9e99e4245400a1a7d4a951386.jpg"
              className="skill-logo"
              alt="skill"
            />
          </div>
          <p className="about headline">CONTACT</p>
          <a
            href="https://www.linkedin.com/in/sumanth-kukudala-8b9837268/"
            className="anchor"
          >
            <img
              src="https://i.pinimg.com/236x/8a/15/b6/8a15b646a6856d20854c2ac22623d971.jpg"
              className="social-logo"
              alt="app"
            />
          </a>
          <a href="https://github.com/sumanth-222" className="anchor">
            <img
              src="https://i.pinimg.com/236x/66/71/3a/66713a96b9b21dffd3a85a5d748a3171.jpg"
              className="social-logo"
              alt="app"
            />
          </a>
          <a href="https://www.instagram.com/__chill_dude/" className="anchor">
            <img
              src="https://i.pinimg.com/236x/95/04/64/950464fcbb88221fba2d72bd8e997118.jpg"
              className="social-logo"
              alt="app"
            />
          </a>
          <p className="gmail">
            G-Mail: <span className="id">sumanthkukudala@gmail.com </span>
          </p>
        </div>
      </div>
    )
  }
}

export default About
